var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordsIcom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 59,
    viewBox: "0 0 67 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_959_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1347 32.5216V50.1645H27.6084C28.2551 50.1645 28.8754 49.9434 29.3327 49.5498C29.7899 49.1562 30.0468 48.6225 30.0468 48.0659V32.5216H62.1347Z",
    fill: "url(#paint0_linear_959_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1336 36.4758V45.5201C20.4538 45.4069 19.8156 45.1547 19.2729 44.7846C18.7302 44.4145 18.2989 43.9374 18.0155 43.3937L4.37758 17.1244C3.91054 16.2277 3.87539 15.2083 4.27984 14.2894C4.68429 13.3704 5.49537 12.6269 6.53547 12.2215L25.7515 4.79297L17.7673 30.013C17.3595 31.2642 17.4728 32.5988 18.0875 33.7858C18.7022 34.9728 19.7798 35.9375 21.1336 36.513V36.4758Z",
    fill: "url(#paint1_linear_959_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8509 30.5056L21.1349 26.4663V34.2477C20.5386 33.7879 20.1027 33.1943 19.8759 32.5335C19.6492 31.8726 19.6405 31.1705 19.8509 30.5056Z",
    fill: "url(#paint2_linear_959_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9799 10.5791L57.362 25.0927H37.3152V21.3784H22.7494L28.6836 2.74195C28.8323 2.27023 29.0877 1.82839 29.4352 1.44178C29.7826 1.05517 30.2153 0.731383 30.7085 0.488979C31.2016 0.246575 31.7455 0.0903228 32.309 0.0291786C32.8725 -0.0319657 33.4444 0.00320067 33.992 0.132662L58.9589 6.01981C60.0615 6.28033 60.9989 6.90677 61.5653 7.76159C62.1317 8.61641 62.2808 9.62974 61.9799 10.5791Z",
    fill: "url(#paint3_linear_959_1751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1601 30.6632H56.7414V26.9489H35.1625V23.2346H23.294V48.0646C23.2718 48.3513 23.3183 48.6389 23.4305 48.9095C23.5427 49.1801 23.7183 49.428 23.9464 49.6379C24.1745 49.8477 24.4503 50.015 24.7566 50.1293C25.0629 50.2437 25.3932 50.3027 25.7271 50.3027C26.0609 50.3027 26.3912 50.2437 26.6975 50.1293C27.0038 50.015 27.2796 49.8477 27.5077 49.6379C27.7358 49.428 27.9114 49.1801 28.0236 48.9095C28.1358 48.6389 28.1823 48.3513 28.1601 48.0646V30.6632Z",
    fill: "url(#paint4_linear_959_1751)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_959_1751",
    x: 0,
    y: 0,
    width: 66.1347,
    height: 58.3027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925 0 0 0 0 0.925 0 0 0 0 0.925 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_1751",
    x1: 60,
    y1: 57,
    x2: 61.4753,
    y2: 22.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247023,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501463,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690614,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916086,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_959_1751",
    x1: 13.4856,
    y1: 47.0959,
    x2: 13.4856,
    y2: 5.15477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_959_1751",
    x1: 19.6995,
    y1: 30.358,
    x2: 21.1342,
    y2: 30.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5395,
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9083,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_959_1751",
    x1: 41.4358,
    y1: 27.6571,
    x2: 41.7297,
    y2: -0.00482006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197633,
    stopColor: "#073B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#1C648E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#2587B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#289FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_959_1751",
    x1: 44.5,
    y1: 42.5,
    x2: 26.7341,
    y2: 13.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247023,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501463,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690614,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916086,
    stopColor: "#006393"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordsIcom);
export default __webpack_public_path__ + "static/media/RecordsIcom.1003383a7af74fe3f3575f58b160b029.svg";
export { ForwardRef as ReactComponent };